// extracted by mini-css-extract-plugin
export default {"informationButtons":"InformationButtons_informationButtons__J1UUh","loginButton":"InformationButtons_loginButton__6C3FY","scrollButton":"InformationButtons_scrollButton__Wkdit"};